const DUPLICATE_COBORROWER_CONFIRMATION_MESSAGES = [
  "coborrower already exists as a coborrower on another app",
  "coborrower already exists as a primary borrower on another app",
  "primary borrower already exists as a coborrower on another app",
] as const;

export const isDuplicateCoborrowerConfirmationError = (
  message: unknown,
): boolean => {
  if (typeof message !== "string") {
    return false;
  }

  const normalizedMessage = message.toLowerCase();
  return DUPLICATE_COBORROWER_CONFIRMATION_MESSAGES.some((duplicateMessage) =>
    normalizedMessage.includes(duplicateMessage),
  );
};
